var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEquaLogoSquare = function SvgEquaLogoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 62,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33BB40",
    d: "M0 0h95v62H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 31.485c0 12.418 10.074 22.484 22.5 22.484 12.42-.013 22.487-10.072 22.5-22.484C70 19.067 59.926 9 47.5 9S25 19.067 25 31.485zm3.709-.007C28.705 21.1 37.116 12.684 47.5 12.675v.017c10.39 0 18.815 8.41 18.826 18.793-.007 10.377-8.428 18.784-18.812 18.782-10.384-.002-18.802-8.413-18.805-18.79z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.822 21.367a4.2 4.2 0 01-4.185 4.2h-10.94a3.64 3.64 0 00-3.635 3.622.273.273 0 01-.273.27.27.27 0 01-.27-.27v-3.913c0-2.319 1.882-4.199 4.202-4.199h14.831a.27.27 0 01.27.29z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.432 28.44H43.697a4.201 4.201 0 00-4.203 4.182v3.913c0 .148.121.27.27.27.15 0 .271-.121.273-.27a3.638 3.638 0 013.642-3.64h7.841a4.2 4.2 0 004.202-4.182.273.273 0 00-.29-.273z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.319 35.786h-8.622a4.201 4.201 0 00-4.203 4.2v3.89a.27.27 0 00.27.274c.151 0 .273-.122.273-.273a3.64 3.64 0 013.642-3.636h4.724a4.2 4.2 0 004.203-4.2.273.273 0 00-.287-.255z",
    fill: "#fff"
  })));
};

export default SvgEquaLogoSquare;